import { Common } from '@thecvlb/design-system/lib/src';

import { ReducedSignupStepProps } from 'containers/SignUp/Content/content.types';

import RegularMeetings from 'assets/images/wm/meet-with-provider.png';

const MarketingRegularMeetings: React.FC<ReducedSignupStepProps> = ({ moveToStep }) => {
  return (
    <div className="flex flex-col items-center gap-6 text-center text-primary-700 md:mx-auto md:max-w-[500px]">
      <img className="w-[200px] rounded-full" src={RegularMeetings} />
      <h3 className="text-mXl md:text-2xl" data-testid="header">
        You’ll consult with a LifeMD-affiliated medical provider every month to monitor your
        progress, make any updates to your GLP-1 treatment plan, and ensure you achieve the best
        results.
      </h3>
      <p className="text-center text-mBase">
        {/* The LifeMD Weight Management Program offers access to a licensed medical provider who will
        craft a personalized treatment plan, including GLP-1 prescription medication where
        clinically appropriate.
        <br /> */}
        <span className="mt-4 block md:font-bold">
          Regular monthly check-ins are key to optimizing your GLP-1 dosage for maximum
          effectiveness. Our program ensures you receive ongoing medical support to track your
          progress, navigate challenges, and reach your goal weight.
        </span>
      </p>
      <Common.Button color="blue" fullWidthOnMobile onClick={() => moveToStep('next')}>
        Continue
      </Common.Button>
    </div>
  );
};

export default MarketingRegularMeetings;
